import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { API_SETTINGS } from './API_SETTINGS';
import { BillingAddress } from '../models/payment/PaymentRequest';
import { PaymentResponse } from '../models/payment/PaymentResponse';
import { CryptoService } from '../services/crypto.service';
import { Discount } from '../models/payment/Discount';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'Payment';

@Injectable({
  providedIn: 'root'
})
export class ApiPaymentService {

  constructor(private http: HttpClient,
    private cryptoService: CryptoService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getPrice(productId: number, billingAddress: BillingAddress): Observable<number> {
    const url = apiUrl + '/Price/' + productId;
    return this.http.post<number>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<number>('getPrice'))
    )
  }

  processPayment(customerId: number, productId: number, token: string, billingAddress: BillingAddress): Observable<PaymentResponse> {
    const url = apiUrl + '/Process/' + customerId + '/' + productId + '/' + token + '/' + this.cryptoService.decryptData(localStorage.getItem("login_email"));
    return this.http.post<PaymentResponse>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<PaymentResponse>('processPayment'))
    )
  }

  processBPPayment(customerId: number, productId: number, billingAddress: BillingAddress): Observable<string> {
    const url = apiUrl + '/BPProcess/' + customerId + '/' + productId + '/' + this.cryptoService.decryptData(localStorage.getItem("login_email"));
    return this.http.post<string>(url, billingAddress, httpOptions).pipe(
      catchError(this.handleError<string>('processBPPayment'))
    )
  }
}